import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setShowEditEmailSettingsModalReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showEditEmailSettingsModal = action.payload;
  });
};

export default setShowEditEmailSettingsModalReducer;
